// @core/api/endpoints/calendar/duplicate_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DuplicateEventRequest,
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Duplicate event
 * Creates a copy of the event with the same details. Optionally specify a new start time and target calendar.
 */
export async function DuplicateEvent(
  event_id: string,
  data: DuplicateEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/duplicate`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
